var defaults = {
    onSubscriberErr: function () { }
};
var guaranteeConfig = function (config) {
    return Object.assign({}, config, defaults);
};
var Topic = (function () {
    function Topic(config) {
        this.config = config;
        this.subscribers = new Set();
    }
    Topic.create = function (config) {
        return new Topic(guaranteeConfig(config));
    };
    Topic.prototype.subscribe = function (consumer) {
        var _this = this;
        this.subscribers.add(consumer);
        return function () { return _this.subscribers.delete(consumer); };
    };
    Topic.prototype.publish = function (event) {
        var _this = this;
        this.subscribers.forEach(function (subscriber) {
            try {
                subscriber(event);
            }
            catch (e) {
                _this.config.onSubscriberErr(e, event);
            }
        });
    };
    return Topic;
}());
export { Topic };
